import script from "./ReportPrintWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPrintWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ReportPrintWrapper.vue?vue&type=style&index=0&id=21e9b8e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e9b8e2"]])

export default __exports__